import { useLocalization } from "@fluent/react";
import { Button, Snackbar } from "@narmi/design_system";
import styles from "./InvoiceContainer.module.scss";

type ZoomActionBarProps = {
  onReset: () => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
  canZoomIn: boolean;
  canZoomOut: boolean;
};

const ZoomActionBar = ({
  onReset,
  onZoomIn,
  onZoomOut,
  canZoomIn,
  canZoomOut,
}: ZoomActionBarProps) => {
  const { l10n } = useLocalization();

  return (
    <div className={styles.zoomActionBar}>
      <Snackbar isActive>
        <Snackbar.ButtonGroup>
          <Button
            kind="tonal"
            startIcon="maximize"
            ariaLabel={l10n.getString("invoice-preview-zoom-reset")}
            onClick={onReset}
          />
        </Snackbar.ButtonGroup>
        <Snackbar.Divider />
        <Snackbar.ButtonGroup>
          <Button
            kind="secondary"
            startIcon="zoom-out"
            ariaLabel={l10n.getString("invoice-preview-zoom-out")}
            onClick={onZoomOut}
            disabled={!canZoomOut}
          />
          <Button
            kind="primary"
            startIcon="zoom-in"
            ariaLabel={l10n.getString("invoice-preview-zoom-in")}
            onClick={onZoomIn}
            disabled={!canZoomIn}
          />
        </Snackbar.ButtonGroup>
      </Snackbar>
    </div>
  );
};

export default ZoomActionBar;
